export const ROLE_PERMISSION_LABEL = {
  root: "Quản trị hệ thống",
  sales: "Nhân viên bán hàng",
  debt: "Nhân viên công nợ",
  admin: "Quản trị viên",
};

export const PERMISSION_OPTIONS = [
  {
    label: "Nhân viên bán hàng",
    value: "sales",
  },
  {
    label: "Nhân viên công nợ",
    value: "debt",
  },
  {
    label: "Quản trị viên",
    value: "admin",
  },
  {
    label: "Quản trị hệ thống",
    value: "root",
  },
];
